export default {
    props: {
        chartAreaBackground: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.background'
        }, 
        chartAreaOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.opacity'
        }, 
        chartAreaBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.border.color'
        }, 
        chartAreaBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'chartArea.border.dashType'
        }, 
        chartAreaBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.border.width'
        }, 
        chartAreaHeight: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.height'
        }, 
        chartAreaMargin: {
            type: [Number, Object],
            default: undefined,
            kComposite: 'chartArea.margin'
        }, 
        chartAreaWidth: {
            type: Number,
            default: undefined,
            kComposite: 'chartArea.width'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoSparkline/ChartArea.js